<template>
  <div class="home">
    <!-- <BackButton @click="goBack"/> -->
    <div class="settingsMethods" v-if="component == null">
      <div class="setting" @click="selectCurrency">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#007AFF" />
          <path d="M12 19.5909C12 21.298 13.1939 22.6818 14.6667 22.6818H17.6754C18.9593 22.6818 20 21.4755 20 19.9874C20 18.8277 19.3597 17.7981 18.4105 17.4313L13.5895 15.5687C12.6403 15.2019 12 14.1723 12 13.0126C12 11.5245 13.0407 10.3182 14.3246 10.3182H17.3333C18.8061 10.3182 20 11.702 20 13.4091M16 8V25" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <div class="settingText">
          <p>{{ $t("main-currency") }}</p>
          <p class="rightText">
            {{ currency }}
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.16666 12.5L6.66666 7L1.16666 1.5" stroke="var(--text-color2)" stroke-opacity="0.3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </p>
        </div>
      </div>
      <hr class="hrSetting" />
      <div class="setting" @click="selectLang">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#8E8E93" />
          <path
            d="M16.725 18.5583L14.6083 16.4667L14.6333 16.4417C16.0451 14.8726 17.0999 13.016 17.725 11H20.1667V9.33333H14.3333V7.66667H12.6667V9.33333H6.83333V10.9917H16.1417C15.5833 12.6 14.7 14.125 13.5 15.4583C12.725 14.6 12.0833 13.6583 11.575 12.6667H9.90833C10.5167 14.025 11.35 15.3083 12.3917 16.4667L8.14999 20.65L9.33333 21.8333L13.5 17.6667L16.0917 20.2583L16.725 18.5583ZM21.4167 14.3333H19.75L16 24.3333H17.6667L18.6 21.8333H22.5583L23.5 24.3333H25.1667L21.4167 14.3333ZM19.2333 20.1667L20.5833 16.5583L21.9333 20.1667H19.2333Z"
            fill="white"
          />
        </svg>
        <div class="settingText">
          <p>{{ $t("language-app") }}</p>
          <p class="rightText">
            {{ $t(`${lang == "RU" ? "russian" : "english"}`) }}
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.16666 12.5L6.66666 7L1.16666 1.5" stroke="var(--text-color2)" stroke-opacity="0.3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </p>
        </div>
      </div>
    </div>
    <div class="settingsMethods" v-if="component == null">
      <div class="setting" @click="selectTheme">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#4C5B69" />
          <path
            d="M15.6188 8.04402C15.7723 7.84136 15.7877 7.56593 15.6578 7.34738C15.528 7.12883 15.2786 7.01073 15.0273 7.04866C10.9689 7.66112 7.875 11.2401 7.875 15.5407C7.875 20.2667 11.6142 24.125 16.2598 24.125C19.8354 24.125 22.8763 21.8364 24.0848 18.6309C24.175 18.3918 24.1105 18.1219 23.922 17.9494C23.7335 17.7769 23.4589 17.7365 23.2287 17.8474C22.4221 18.236 21.5218 18.4532 20.5709 18.4532C17.1214 18.4532 14.2982 15.5805 14.2982 12.0033C14.2982 10.5088 14.7918 9.13587 15.6188 8.04402Z"
            fill="white"
          />
        </svg>

        <div class="settingText">
          <p>{{ $t("themeApp") }}</p>
          <p class="rightText">
            {{ $t(`${theme}Theme`) }}
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.16666 12.5L6.66666 7L1.16666 1.5" stroke="var(--text-color2)" stroke-opacity="0.3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </p>
        </div>
      </div>
    </div>
    <div class="settingsMethods" v-if="component == null" @click="openSupport">
      <div class="setting">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#5755D7" />
          <path
            d="M22.6667 14.3333C22.6667 10.6514 19.6819 7.66667 16 7.66667C15.1159 7.66667 14.272 7.83876 13.5 8.15126M18.0833 24.0014C20.7449 23.1265 22.6667 20.621 22.6667 17.6667M13.9167 24.0014C11.2551 23.1265 9.33333 20.621 9.33333 17.6667V14.3333C9.33333 12.7568 9.88059 11.308 10.7955 10.1667M16 14.3333V17.6667M12.6667 17.6667V14.3333C12.6667 12.4924 14.159 11 16 11M18.8874 12.6667C19.171 13.157 19.3333 13.7262 19.3333 14.3333V17.6667C19.3333 19.5076 17.8409 21 16 21C15.3928 21 14.8236 20.8377 14.3333 20.5541"
            stroke="white"
            stroke-width="1.3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="settingText">
          <p>{{ $t("verification") }}</p>
          <p class="rightText">
            {{ isVerify ? $t("have") : $t("no") }}
            {{ this.$store.getters.getVerifictaion }}
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!isVerify">
              <path d="M1.16666 12.5L6.66666 7L1.16666 1.5" stroke="var(--text-color2)" stroke-opacity="0.3" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </p>
        </div>
      </div>
    </div>
    <div class="settingsMethods" v-if="component == null" @click="openTos">
      <div class="setting">
        <p style="color: #007aff; font-size: 16px">{{ $t("tos") }}</p>
      </div>
    </div>
    <SelectLanguage v-if="component == 'SelectLanguage'" @changeMode="selectLang" />
    <SelectCurrency v-if="component == 'SelectCurrency'" @changeMode="selectCurrency" />
    <SelectTheme v-if="component == 'SelectTheme'" @changeMode="selectTheme" />
  </div>
</template>

<script>
import SelectCurrency from "@/components/SelectCurrency.vue";
import SelectLanguage from "@/components/SelectLanguage.vue";
import SelectTheme from "@/components/SelectTheme.vue";
import { UserManager } from "@/utils/userManager";
import axios from "axios";
import { onMounted, onUnmounted, ref } from "vue";
import { useWebAppBackButton } from "vue-tg";

export default {
  name: "MainPage",
  data() {
    return {
      currency: this.$store.getters.getCurrency,
      lang: this.$store.getters.getLanguage,
      theme: this.$store.getters.getTheme,
      componentS: "",
      user: null,
      botId: null,
      isVerify: this.$store.getters.getVerification || false,
    };
  },
  setup() {
    const component = ref(null); // Отслеживаем активный компонент
    const backB = useWebAppBackButton();

    // const defaultBackAction = () => {
    //   window.history.back();
    // };
    backB.onBackButtonClicked(() => {
      if (component.value == null) window.history.back();
      else component.value = null;
    });
    // Перемещаем регистрацию обработчика сюда
    onMounted(() => {
      backB.showBackButton(); // Показываем кнопку назад
    });

    onUnmounted(() => {
      backB.hideBackButton(); // Скрываем кнопку назад при размонтировании компонента
    });

    return { backB, component };
  },
  methods: {
    goBack() {
      // if (this.component == "") window.history.back()
      // else {
      //   console.log("иеиееи")
      // }
    },
    openSupport() {
      if (!this.user || !this.botId) {
        console.error("Нет данных пользователя для запроса ТП");
        return;
      }

      fetch(`${window.location.origin}/tech/tp?bot_id=${this.botId}&user_id=${this.user.id}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.tp) {
            const supportLink = `https://t.me/${data.tp}`;
            window.location.href = supportLink;
          } else {
            // Fallback на дефолтную ссылку если что-то пошло не так
            window.location.href = "https://t.me/";
          }
        })
        .catch((err) => {
          console.error("Ошибка при получении ссылки на ТП:", err);
          // Fallback на дефолтную ссылку при ошибке
          window.location.href = "https://t.me/";
        });
    },
    openTos() {
      if (!this.botId) {
        console.error("Нет botId для запроса пользовательского соглашения");
        return;
      }

      fetch(`${window.location.origin}/tech/tos?bot_id=${this.botId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.url) {
            const tg = window.Telegram?.WebApp;
            if (tg?.openLink) {
              tg.openLink(data.url);
            } else {
              window.open(data.url, "_blank");
            }
          }
        })
        .catch((err) => {
          console.error("Ошибка при получении ссылки на пользовательское соглашение:", err);
        });
    },
    selectLang(el) {
      // this.component = this.component === "SelectLanguage" ? "" : "SelectLanguage";
      console.log(this.component);
      if (this.componentS == "SelectLanguage") {
        this.componentS = null;
        this.component = null;
        this.lang = this.$store.getters.getLanguage;
        console.log("МЕНЯЕМ НАЗАД");
      } else {
        this.componentS = "SelectLanguage";
        this.component = "SelectLanguage";
        console.log(this.component, "ПОМЕНЯЛ");
      }
      console.log(this.component, "ПОМЕНЯН", el);
      setTimeout(() => this.backB.showBackButton(), 100);
      // this.backB.showBackButton();
    },
    selectCurrency(el) {
      console.log(this.component);
      if (this.componentS == "SelectCurrency") {
        this.componentS = null;
        this.component = null;
        this.currency = this.$store.getters.getCurrency;
        console.log("МЕНЯЕМ НАЗАД");
      } else {
        this.componentS = "SelectCurrency";
        this.component = "SelectCurrency";
        console.log(this.component, "ПОМЕНЯЛ");
      }
      console.log(this.component, "ПОМЕНЯН", el);
      setTimeout(() => this.backB.showBackButton(), 100);
    },
    selectTheme(el) {
      console.log(this.component);
      if (this.componentS == "SelectTheme") {
        this.componentS = null;
        this.component = null;
        this.theme = this.$store.getters.getTheme;
        console.log("МЕНЯЕМ НАЗАД");
      } else {
        this.componentS = "SelectTheme";
        this.component = "SelectTheme";
        console.log(this.component, "ПОМЕНЯЛ");
      }
      console.log(this.component, "ПОМЕНЯН", el);
      setTimeout(() => this.backB.showBackButton(), 100);
    },
    async checkVerify() {
      try {
        const response = await axios.get(`${window.location.origin}/user/verification/${this.botId}/${this.user.id}`);
        console.log(response);
        let verify = response.data == 0 ? false : true;
        this.isVerify = verify;
        this.$store.commit("setVerification", this.isVerify);
        console.log(this.$store.getters.getVerification, verify);
      } catch (err) {
        console.log(err);
      }
    },
    initializeUser() {
      // Получаем данные пользователя из store или инициализируем заново
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;

      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
        console.log("Данные пользователя из store:", this.user, this.botId);
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
        console.log("Новые данные пользователя:", this.user, this.botId);
      }
    },
  },
  mounted() {
    this.initializeUser();
    this.checkVerify();
  },
  components: { SelectLanguage, SelectCurrency, SelectTheme },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}
.settingsMethods {
  border-radius: 14px;
  background-color: var(--second-color);
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
}
.setting {
  font-size: 18px;
  color: var(--text-color1);
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
}
.setting:active {
  scale: 0.97;
}
.hrSetting {
  width: 85%;
  float: right;
  position: absolute;
  right: 0;
  top: 50%;
  border: 0.5px solid var(--hr-color);
}
.rightText {
  color: var(--text-color2);
  display: flex;
  align-items: center;
  gap: 10px;
}
.settingText {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
